import React from 'react';
import { CircularProgress, Dialog, DialogContent } from '@material-ui/core';
import styles from './LoaderDialog.module.css';

function LoaderDialog() {
  return (
    <Dialog open={true} disableBackdropClick>
      <DialogContent className={styles.root}>
        <CircularProgress
          className={styles.bgWhite}
          size={30}
          thickness={6}
        />
        <div className={styles.text}>
          Processing...
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default LoaderDialog;
